import { render } from "./Alignment.vue?vue&type=template&id=6c0b2b70"
import script from "./Alignment.vue?vue&type=script&lang=js"
export * from "./Alignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__